import { render, staticRenderFns } from "./attachmentseditor.vue?vue&type=template&id=1c41b490&lang=pug"
import script from "./attachmentseditor.vue?vue&type=script&lang=js"
export * from "./attachmentseditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports